import { useAppStore } from "@/stores/app.store";

export function useEmbedAutoResize() {
  const appStore = useAppStore();

  if (!appStore.isEmbed) return;

  // The child module self-initializes on import.
  // It calls initializeChildListener() at module level, which:
  // 1. Checks it's running in an iframe (window.self !== window.top)
  // 2. Adds a 'message' listener for 'iframe-child-init' from parent
  // 3. On init message, starts ResizeObserver on document.documentElement
  // 4. Sends 'iframe-resized' messages to parent on height changes
  import("@open-iframe-resizer/core").catch((error) => {
    console.error("[useEmbedAutoResize] Failed to load resize script", error);
  });
}
